const muiTableOverrides = {
  styleOverrides: {
    root: {
      borderSpacing: '0 5px',
    },
  },
};

export default muiTableOverrides;
